import React from "react";
import Styles from "./Footer.module.scss";

const Footer = () => {
    return <div className={Styles.footerContainer}>Copyright</div>;
};

export default Footer;
